import { useLocation, useNavigate } from 'react-router-dom';

import { isPotentiallyAuthenticated } from 'services/auth/auth';
import { useCurrentUser } from 'services/repositories/user/user';
import { DashboardRoutes } from 'support/types';
import { LoadingPage } from 'components/Loading/LoadingPage';

export function AuthPage({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();
  const location = useLocation();
  const redirectUrl: string = location.state?.from || DashboardRoutes.root;

  const { isLoading, isError } = useCurrentUser({
    enabled: isPotentiallyAuthenticated(),
    onSuccess: () => {
      // Only redirect if we successfully retrieved the user
      navigate(redirectUrl, { replace: true });
    },
  });

  if (isLoading && !isError && isPotentiallyAuthenticated()) {
    return (
      <div className="mx-auto h-screen">
        <LoadingPage />
      </div>
    );
  }

  return <div className="flex min-h-screen flex-col bg-gray-50 py-12 pt-28 sm:px-6 lg:px-8">{children}</div>;
}
